import script from "./AnnouncementList.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementList.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementList.vue?vue&type=style&index=0&id=b7a9ebb2&lang=scss"

const __exports__ = script;

export default __exports__